import wbeDataApi from './wbeDataApi'

export { setReduxHooks } from './cfeAuthApi'
export default wbeDataApi



// WEBPACK FOOTER //
// ./src/utils/http-clients/index.ts